import strings from '../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.technicalData.name.label,
  defaultValue: '',
  validators: [
    // {
    //   id: 'assertEmpty',
    //   type: 'lengthMin',
    //   conf: {
    //     min: 1
    //   },
    //   invalidFeedback: strings.form.technicalData.name.invalid.assertEmpty,
    //   defaultValue: false
    // },
  ]
}

let codingValue = {
  fieldKey: "coding_value",
  type: "text",
  label: strings.form.technicalData.codingValue.label,
  validators: []
}

let ciphered = {
  fieldKey: "ciphered",
  type: "switch",
  label: strings.form.technicalData.ciphered.label,
  defaultValue: false,
  validators: []
}

let active = {
  fieldKey: "active",
  type: "switch",
  label: strings.form.technicalData.active.label,
  defaultValue: false,
  validators: []
}

let availableOrder = {
  fieldKey: "available_order",
  type: "switch",
  label: strings.form.technicalData.availableOrder.label,
  defaultValue: false,
  validators: []
}

let availableService = {
  fieldKey: "available_service",
  type: "switch",
  label: strings.form.technicalData.availableService.label,
  defaultValue: false,
  validators: []
}

let clientReadable = {
  fieldKey: "client_readable",
  type: "switch",
  label: strings.form.technicalData.clientReadable.label,
  defaultValue: false,
  validators: []
}

let clientWritable = {
  fieldKey: "client_writable",
  type: "switch",
  label: strings.form.technicalData.clientWritable.label,
  defaultValue: false,
  validators: []
}

let searchable = {
  fieldKey: "searchable",
  type: "switch",
  label: strings.form.technicalData.searchable.label,
  defaultValue: false,
  validators: []
}

let searchCipheredMeaningfulCharacterMin = {
  fieldKey: "search_ciphered_meaningful_character_min",
  type: "text",
  label: strings.form.technicalData.searchCipheredMeaningfulCharacterMin.label,

  showOnDisabled: (getValues) => {
    let values = getValues(0);
    return values["ciphered"] && values["searchable"];
  },
  disabled: (getValues) => {
    let values = getValues(0);
    return !(values["ciphered"] && values["searchable"]);
  },

  validators: [
    {
      id: 'assertNumber',
      type: 'regex',
      conf: {
        regex: /^\d+/
      },
      invalidFeedback: strings.form.technicalData.searchCipheredMeaningfulCharacterMin.invalid.assertNumber,
      defaultValue: true
    },
  ]
}

let searchCipheredMeaningfulCharacterMax = {
  fieldKey: "search_ciphered_meaningful_character_max",
  type: "text",
  label: strings.form.technicalData.searchCipheredMeaningfulCharacterMax.label,

  showOnDisabled: (getValues) => {
    let values = getValues(0);
    return values["ciphered"] && values["searchable"];
  },
  disabled: (getValues) => {
    let values = getValues(0);
    return !(values["ciphered"] && values["searchable"]);
  },

  validators: [
    {
      id: 'assertNumber',
      type: 'regex',
      conf: {
        regex: /\d+/
      },
      invalidFeedback: strings.form.technicalData.searchCipheredMeaningfulCharacterMax.invalid.assertNumber,
      defaultValue: true
    },
  ]
}

let displayBillOrder = {
  fieldKey: "display_bill_order",
  type: "text",
  label: strings.form.technicalData.displayBillOrder.label,
  defaultValue: null,
  validators: [
    {
      id: 'assertNumber',
      type: 'regex',
      conf: {
        regex: /\d+/
      },
      invalidFeedback: strings.form.technicalData.displayBillOrder.invalid.assertNumber,
      defaultValue: true
    },
  ]
}

export const form = {
  formKey: "technicalData",
  fields: [
    name,
    codingValue,
    ciphered,
    active,
    availableOrder,
    availableService,
    clientReadable,
    clientWritable,
    searchable,
    searchCipheredMeaningfulCharacterMin,
    searchCipheredMeaningfulCharacterMax,
    displayBillOrder,
  ]
}
